import { cloneDeep } from '@/utils/utils'

function setGamerCondition (event) {
  const { extra, EventCode } = event
  const { getIngameData, currentSportEvents } = this
  const { gamerCondition } = getIngameData

  const value = cloneDeep(gamerCondition)

  value[extra.team === 1 ? 'home' : 'away'] = {
    eventCode: EventCode,
    title: currentSportEvents[EventCode].title
  }

  this.setIngameProperty({
    property: 'gamerCondition',
    value
  })
}

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'GAMER_CONDITION_HEADACHE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_HIGH_TEMPERATURE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_INTOXICATION' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_NORMAL' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_TILT' (event) {
      setGamerCondition.call(this, event)
    },
    'MATCH_FORMAT' (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format,
        has_tackles,
        basketball_throws
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set,
        has_tackles
      })

      this.setIngameProperty({
        property: 'shotoutOnly',
        value: !!basketball_throws
      })

      this.setIngameProperty({
        property: 'hasTimer',
        value: !basketball_throws
      })

      if (basketball_throws)  return

      if (is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
  }
}
